module.exports = __webpack_public_path__ + "img/note-attention.31958d59.svg";